import { render, staticRenderFns } from "./WebcretariumDiscordBot.vue?vue&type=template&id=1fb53bf8&scoped=true"
import script from "./WebcretariumDiscordBot.vue?vue&type=script&lang=js"
export * from "./WebcretariumDiscordBot.vue?vue&type=script&lang=js"
import style0 from "./WebcretariumDiscordBot.vue?vue&type=style&index=0&id=1fb53bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb53bf8",
  null
  
)

export default component.exports